import AssignmentSettings from '../../../../../../../../components/AssignmentSettings/index';
import GoogleClassroomShareModal from '../../../../../../../../components/GoogleClassroomShareModal/index';
import AssignmentLinksModal from '../../../../../../../../components/AssignmentLinksModal/index';
import HesSpinner from '../../../../../../../../components/loadingOverlay/hesSpinner';
import CustomToast from '../../../../../../../../components/Toast';
import { useAssignmentContext } from '../../../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faLink, faCopy } from '@fortawesome/free-solid-svg-icons';
import { useGetUserIdMutation } from '../../../../../../../../features/authentication/dashboardHeaderApiSlice';
import { useCreateAssignmentLinkMutation } from '../../../../../../../../features/authentication/assignApiSlice';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import Modal from '../../../../../../../../components/Modal';
import moment from 'moment';

function AssignExternal() {
  const { assignmentAssignedViaDetails, assignmentId } = useAssignmentContext();
  const [showAssignmentLinksModal, setShowAssignmentLinksModal] = useState(false);
  const [showShareToGoogleClassroomModal, setShowShareToGoogleClassroomModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const selectedAssignment = useAssignmentContext();
  const { assignmentName, setAssignmentOptions} = useAssignmentContext();
  const [createLinkIsLoading, setCreateLinkIsLoading] = useState(false);
  const [createAssignmentLinkCall] = useCreateAssignmentLinkMutation();
  const [getUserId, userIdResults] = useGetUserIdMutation();
  const createdAssignmentLink = useRef('');

  useEffect(() => {
    getUserId();
  }, []);

  async function createAssignmentLink() {
    const timedTimeSpan =
      parseInt(selectedAssignment.timedHour) * 60 + parseInt(selectedAssignment.timedMinute);
    var selfStudentModel = [{ studentId: userIdResults.data.userId, classId: -1 }];

    if (!selectedAssignment.assignmentMode) {
      CustomToast('Please select the assignment mode', 'warning');
      return;
    }
    if (selectedAssignment.isTimed && timedTimeSpan <= 0) {
      CustomToast('The time length must be greater than 0 minutes.', 'info');
      return;
    }

    if (selectedAssignment.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(selectedAssignment.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(moment(selectedAssignment.startDate)) || moment(selectedAssignment.endDate).isSame(moment(selectedAssignment.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }

    if (selectedAssignment.retakesEnabled) {
      if (selectedAssignment.retakeLimitValue <= 0) {
        CustomToast('You must select a retake limit', 'info');
        return;
      }
      if (selectedAssignment.retakeQuestion === null) {
        CustomToast(
          'You must select an option for Auto Graded Questions to include on Retakes',
          'info'
        );
        return;
      }
      if (selectedAssignment.includeCR === null) {
        CustomToast('You must select an option for CR Questions to include on Retakes', 'info');
        return;
      }
    }
    setCreateLinkIsLoading(true);

    try {
      const options = {
        assignmentIds: [parseInt(assignmentId)],
        students: selfStudentModel,
        selfAssign: false,
        availability: selectedAssignment.availabilityOption,
        assignmentMode: selectedAssignment.assignmentMode,
        allowAnswerChange: selectedAssignment.allowAnswerChange,
        showGrade: selectedAssignment.showGrade,
        startDate: selectedAssignment.startDate,
        endDate: selectedAssignment.endDate,
        studentFileUpload: selectedAssignment.studentFileUpload,
        timed: selectedAssignment.isTimed,
        timeSpan: timedTimeSpan,
        practice: true,
        assignRetake: selectedAssignment.retakesEnabled,
        masteryLevel: selectedAssignment.masteryValue,
        retakeMode: selectedAssignment.assignmentMode,
        scoreRetries: selectedAssignment.scoreRetries,
        retakeLimit: selectedAssignment.retakeLimitValue,
        retakeAvailabilty: selectedAssignment.availabilityOption,
        retakeStartDate: selectedAssignment.startDate,
        retakeEndDate: selectedAssignment.endDate,
        retakeTimed: selectedAssignment.isTimed,
        retakeTimeSpan: timedTimeSpan,
        retakeQuestion: selectedAssignment.retakeQuestion,
        includeCR: selectedAssignment.includeCR,
        randomized: selectedAssignment.randomized,
        textToSpeech: selectedAssignment.textToSpeech,
        autoLockQuestions: selectedAssignment.autoLockQuestions,
        allowLangChange: selectedAssignment.allowLangChange,
        useCalc: selectedAssignment.calculatorEnabled ? 1 : 0,
        useProtractor: selectedAssignment.useProtractor ? 1 : 0,
        useRuler: selectedAssignment.useRuler ? 1 : 0,
        timeOnTask: selectedAssignment.timeOnTaskEnabled,
        period: selectedAssignment.timeOnTaskSeconds,
        lockBrowser: selectedAssignment.lockBrowser,
        photoMathBlock: selectedAssignment.photoMathBlock,
        autoStartCRUponGrading: selectedAssignment.autoStartCRUponGrading,
        cranswerToolId: selectedAssignment.crAnswerToolType,
        calculatorType: selectedAssignment.calculatorType
      };
      setAssignmentOptions(options);
      createdAssignmentLink.current = await createAssignmentLinkCall(options).unwrap();
      if (createdAssignmentLink.current.length > 1) {
        setCreateLinkIsLoading(false);
        CustomToast(
          'Assignment links have been created, you can find them under "View Assignment Links"',
          'success'
        );
      } else if (createdAssignmentLink.current.length === 1) {
        setShowLinkModal(true);
        setCreateLinkIsLoading(false);
      } else {
        CustomToast('Error! Couldn\'t create assignment link', 'error');
      }
    } catch (ex) {
      CustomToast('Error! Couldn\'t create assignment link', 'error');
      setCreateLinkIsLoading(false);
    }
  }

  function createAndShareToGoogle() {
    const timedTimeSpan =
      parseInt(selectedAssignment.timedHour * 60) + parseInt(selectedAssignment.timedMinute);
    var selfStudentModel = [{ studentId: userIdResults.data.userId, classId: -1 }];

    if (!selectedAssignment.assignmentMode) {
      CustomToast('Please select the assignment mode', 'warning');
      return;
    }
    if (selectedAssignment.isTimed && timedTimeSpan <= 0) {
      CustomToast('The time length must be greater than 0 minutes.', 'info');
      return;
    }

    if (selectedAssignment.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(selectedAssignment.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(moment(selectedAssignment.startDate)) || moment(selectedAssignment.endDate).isSame(moment(selectedAssignment.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }

    if (selectedAssignment.retakesEnabled) {
      if (selectedAssignment.retakeLimitValue <= 0) {
        CustomToast('You must select a retake limit', 'info');
        return;
      }
      if (selectedAssignment.retakeQuestion === null) {
        CustomToast(
          'You must select an option for Auto Graded Questions to include on Retakes',
          'info'
        );
        return;
      }
      if (selectedAssignment.includeCR === null) {
        CustomToast('You must select an option for CR Questions to include on Retakes', 'info');
        return;
      }
    }
    const optionsRef = {
      assignmentIds: [parseInt(assignmentId)],
      students: selfStudentModel,
      selfAssign: false,
      availability: selectedAssignment.availabilityOption,
      assignmentMode: selectedAssignment.assignmentMode,
      allowAnswerChange: selectedAssignment.allowAnswerChange,
      showGrade: selectedAssignment.showGrade,
      startDate: selectedAssignment.startDate,
      endDate: selectedAssignment.endDate,
      studentFileUpload: selectedAssignment.studentFileUpload,
      timed: selectedAssignment.isTimed,
      timeSpan: timedTimeSpan,
      practice: true,
      assignRetake: selectedAssignment.retakesEnabled,
      masteryLevel: selectedAssignment.masteryValue,
      retakeMode: selectedAssignment.assignmentMode,
      scoreRetries: selectedAssignment.scoreRetries,
      retakeLimit: selectedAssignment.retakeLimitValue,
      retakeAvailabilty: selectedAssignment.availabilityOption,
      retakeStartDate: selectedAssignment.startDate,
      retakeEndDate: selectedAssignment.endDate,
      retakeTimed: selectedAssignment.isTimed,
      retakeTimeSpan: timedTimeSpan,
      retakeQuestion: selectedAssignment.retakeQuestion,
      includeCR: selectedAssignment.includeCR,
      randomized: selectedAssignment.randomized,
      textToSpeech: selectedAssignment.textToSpeech,
      autoLockQuestions: selectedAssignment.autoLockQuestions,
      allowLangChange: selectedAssignment.allowLangChange,
      useCalc: selectedAssignment.calculatorEnabled ? 1 : 0,
      useProtractor: selectedAssignment.useProtractor ? 1 : 0,
      timeOnTask: selectedAssignment.timeOnTaskEnabled,
      period: selectedAssignment.timeOnTaskSeconds,
      lockBrowser: selectedAssignment.lockBrowser,
      photoMathBlock: selectedAssignment.photoMathBlock,
      autoStartCRUponGrading: selectedAssignment.autoStartCRUponGrading,
      cranswerToolId: selectedAssignment.crAnswerToolType,
      calculatorType: selectedAssignment.calculatorType
    };
    setAssignmentOptions(optionsRef);
    setShowShareToGoogleClassroomModal(true);  
  }

  function copyLinkToClipboard(fullUrl) {
    navigator.clipboard.writeText(fullUrl);
    CustomToast('Link copied', 'info');
  }

  return (
    <div>
      <AssignmentLinksModal
        showAssignmentLinksModal={showAssignmentLinksModal}
        setShowAssignmentLinksModal={setShowAssignmentLinksModal}
        showAssignedViaFilter={false}
        assignmentIdFilter={[parseInt(assignmentId)]}
      />
      
      <div className="my-2 w-75">
        <AssignmentSettings
          headingDescription={false}
          availabilityRequired={true}
          allowOfflineMode={false}
          modesRequired={true}
          showBetaButton={true}
          noColumn={true}
          randomizedQuestion={true}
          disabledTextSpeach={true}
          isSelfAssign={false}
        />
      </div>
      {showShareToGoogleClassroomModal &&
      <GoogleClassroomShareModal
        showShareToGoogleClassroomModal={showShareToGoogleClassroomModal}
        setShowShareToGoogleClassroomModal={setShowShareToGoogleClassroomModal}
        assignmentName={assignmentName}
      />
      }

      <div className="d-flex flex-row justify-content-end w-75">
        <button onClick={() => setShowAssignmentLinksModal(true)} className="btn btn-castleWhite primary-link">
          <FontAwesomeIcon className='px-1' icon={faLink} />
        View links for this Assignment
        </button>
        <Button
          variant="castleRed"
          className={`pt-2 d-flex flex-row justify-content-${
            createLinkIsLoading ? 'between' : 'center'
          } mx-2`}
          onClick={() => createAssignmentLink()}
          disabled={createLinkIsLoading}>
          {createLinkIsLoading && (
            <div style={{ height: '120%' }}>
              <HesSpinner />
            </div>
          )}
          {createLinkIsLoading ? 'Creating Assignment Link...' : 'Create Assignment Link'}
        </Button>

        {assignmentAssignedViaDetails.id == 2 && (
          <button className="createAndShareToGoogleBtn" onClick={() => createAndShareToGoogle()}>
            <FontAwesomeIcon icon={faUsers} />
            <div className="ms-2">Create link & share to Google Classroom</div>
          </button>
        )}
      </div>
      <Modal
        contentWidth="40%"
        isOpen={showLinkModal}
        titleName={'Link Created'}
        onClose={() => {
          setShowLinkModal(false);
        }}>
        <div className="d-flex flex-column align-items-center">
          <div>
            An assignment link has been created! Click the icon below to copy it to your clipboard
            now.
          </div>

          <OverlayTrigger
            key="copyToClipboard"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Copy to Clipboard</Tooltip>}>
            <button
              className="copyLinkBtn my-3"
              onClick={() => copyLinkToClipboard(createdAssignmentLink.current[0])}>
              <FontAwesomeIcon icon={faCopy} />
            </button>
          </OverlayTrigger>

          <div>You can also find this link under &quot;View Assignment Links&quot;.</div>
        </div>
      </Modal>
    </div>
  );
}

export default AssignExternal;
